export const epsilonLabsExperiments = [
	{
		id: 225,
		cookieName: 'experiment_225_running',
	},
	{
		id: 387,
		variationId: 723,
		cookieName: 'experiment_387_723_running',
	},
];